import axios from 'axios';

class MicrosoftWebservice {
    public async getUsers() {
        return await axios.get('/integrations/microsoft/users');
    }

    public async getJobStatus(projectId: number) {
        return await axios.post('/integrations/microsoft/jobStatus', { projectId });
    }
}

export const microsoftWebservice = new MicrosoftWebservice();
